import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = (token, path) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    path: path
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expirationDate");
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000);
  };
};

export const loadCurrentUserDetail = (data) => {
  return {
    type: actionTypes.LOAD_CURRENT_USER_DETAIL,
    payload: data
  }
}

export const currentUserDetail = (token) => {
  return async dispatch => {
    let url = `${api}/users/currentUserDetail`;
    const options = {
      url: url,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data: {}
    };
    axios(options)
      .then(response => {
        dispatch(loadCurrentUserDetail(response.data));
      })
      .catch(err => {
        console.log('failed to load current user');
      });
  }
}

export const auth = (username, password) => {
  return dispatch => {
    //authenticate the user
    dispatch(authStart());
    let url = `${api}/auth/admin/login`;
    const options = {
      url: url,
      method: 'POST',
      headers: {},
      data: {
        username: username,
        password: password
      }
    };
    axios(options)
      .then(response => {
        const expirationDate = new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        );
        localStorage.setItem("token", response.data.accessToken);
        localStorage.setItem("expirationDate", expirationDate);
        dispatch(authSuccess(response.data.accessToken));
        dispatch(checkAuthTimeout(24 * 60 * 60));
        dispatch(setAuthRedirectPath("/"));
      })
      .catch(err => {
        dispatch(authFail(`no token - ${err}`));
        dispatch(setAuthRedirectPath("/login"));
      });
  };
};

export const setAuthRedirectPath = path => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  };
};

export const authCheckState = (path) => {
  return dispatch => {
    const token = localStorage.getItem("token");
    if (!token) {
      dispatch(logout());
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      if (expirationDate <= new Date()) {
        dispatch(logout());
      } else {
        dispatch(authSuccess(token));
        dispatch(
          checkAuthTimeout(
            (expirationDate.getTime() - new Date().getTime()) / 1000
          )
        );
      }
    }
  };
};